module.exports = __webpack_public_path__ + "img/top-banner.edbb07be.png";